import CIMSTable from 'components/CIMSTable'
import { useUsersTableContext } from '../../UsersTableContext'
import { useColumns } from './hooks/useColumns'
import { useEditOptions } from './hooks/useEditOptions'
import EditUserModal from './hooks/useEditOptions/components/EditUserModal'
import { useExpandOptions } from './hooks/useExpandOptions'

export const UsersTable: React.FC = () => {
  const {
    records,
    refetch,
    fetching,
    editModal: { toggle, ...rest },
  } = useUsersTableContext()
  const columns = useColumns()
  const editOptions = useEditOptions()
  const expand = useExpandOptions()

  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={columns}
      actions={{
        header: { onReload: refetch, deepLinkKey: 'id' },
        row: { edit: editOptions },
      }}
      expand={expand}
    >
      <EditUserModal {...rest} onClose={() => toggle(null)} />
    </CIMSTable>
  )
}
